var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownlaugh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 334.1 394.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-4, .cls-6 {\n        fill: none;\n      }\n\n      .cls-1, .cls-7 {\n        stroke: #757575;\n      }\n\n      .cls-2 {\n        fill: #e9e8e8;\n        stroke: #e9e8e8;\n      }\n\n      .cls-3 {\n        fill: #4c4c4c;\n      }\n\n      .cls-3, .cls-4 {\n        stroke: #4b4c4c;\n      }\n\n      .cls-5 {\n        fill: #bababb;\n        stroke: #bababb;\n      }\n\n      .cls-6, .cls-8 {\n        stroke: #767576;\n      }\n\n      .cls-7 {\n        fill: #757576;\n      }\n\n      .cls-8 {\n        fill: #767576;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M301.7,280.8c-9.5-20.1-24.3-44.8-29.5-48.5-5.2-3.7-18.3-8.9-18.3-8.9,0,0,18-12.9,20.2-19.3,4.2-12.5-8.1-35-8.9-40.3s-8.4-27.5-9.5-41.1c-1.1-13.6-7.8-58.7-9.4-63.5s-12.4-28.3-16.9-30.5S189.6,3.3,184.2,3.3h-35.8c-5.4,0-40.7,23.2-45.2,25.4s-15.3,25.7-16.9,30.5c-1.6,4.8-8.3,49.9-9.4,63.5-1.1,13.6-8.7,35.8-9.5,41.1s-13.1,27.8-8.8,40.3c2.2,6.4,20.2,19.3,20.2,19.3,0,0-13.2,5.2-18.3,8.9-5.1,3.7-20,28.4-29.5,48.5-9.5,20.1-23.8,52-29.5,58.7l163.8,13.2,1-44.5v-27.7,27.7c0,0,1.1,44.5,1.1,44.5l163.8-13.2c-5.7-6.7-20-38.6-29.5-58.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.4,69.5c-9.8-9.5-40.1-36.2-47.4-39h-1.2c-.1,0-.3,0-.5,0-.2,0-.4,0-.5,0l-1.4.2c-7.3,2.8-37.4,29.3-47.2,38.8-7,6.9-30.7,65.4-30.7,65.4v22.6l15.6,22.6s34.5,63.7,40,70.4c5.5,6.7,20.7,46.5,20.7,46.5h7s15.2-39.8,20.7-46.5c5.5-6.7,40-70.4,40-70.4l15.6-22.6v-22.6s-23.7-58.5-30.7-65.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.3,350.9s20.1-44.8,24-55.7c4.2-11.8,3.6-24,3.6-24,0,0,5.9,18.8,5.9,31.6v57.8l-33.5-9.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.2,247.3s29.1,45.3,29.1,56.7,11.4,64.4,11.4,64.4l23.6-13.5-1.6-35.7-46-50.7-16.6-21.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.4,283l-5.7,69.6s14.4-50,18-56.6,23.2-49.6,26.9-48.7,26.6,13.7,26.9,17.4,38.9,79.6,38.9,93.7l28.2-12.8-37.9-78.1s-20.9-35.8-23.8-36-14.2-6-14.2-6c0,0-27.4,20.8-31.8,27.9-4.4,7.1-25.6,29.5-25.6,29.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.2,348.5c.4-13.6,7-84.9,7-84.9,0,0,11.8,11.2,13.3,24.3,1.1,9.6,10,64.8,10,64.8l-30.2-4.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.8,68s1.8,3.7,1.8,6.9-3.6,6.5-3.1,12.6c1.6,17.3,39.6,45.7,47.8,45.8s36.2-23.8,39.7-27.9c30.2-35.9-20.1-63.4-22.1-60.9l-7.3,4s-4.8,2-9.1,1.5-17-4.6-17-4.6c0,0-16.8,8.5-20.3,13.2s-10.4,9.3-10.4,9.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122.3,62.6s24-15.1,36.8-15.5c-2.7-.7-7.1.5-9.6-1.8-6.1-.5-16.7,10.4-27.2,17.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.8,58s-18.1-10.8-30.9-11.2c2.7-.7,6.9.8,9.4-1.5,8.5,0,13.2,6.7,21.4,12.7h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M184.6,48.7s14.3,9.1,16.2,15.1c2.1,6.5-2.9,2.8-2.9,2.8l-6.9,1.1s10,4.8,9.2,10.9c-1.5,11.3-14.8,44.4-19.1,49.6,0,0,30.8-28.9,32.6-33.3s-.1-13-1.6-18.8,1.6-9.7,1.6-9.7c0,0-9.2-9-13.6-10.4s-15.4-7.3-15.4-7.3c0,0-.1,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M184.6,48.7c1,5.8-5.3,4.1-11.1,5.1-2.6.5-6.5,15-6.5,15l9.5,9.9s-1.3-11.7.4-13.1,21.9-4,21.9-4l-14.2-12.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.1,47.3c12.1,0,16-4.8,16-4.8,0,0,3.5.7,9.4,3.3,2.7,1.2,5.6,4.1,8.3,6.6,10.9,9.8,15.2,15.3,15.2,15.3-.8,1.2-1.9,3.2-1.8,5.8,0,1.8,9.1,9.9-1.6,26.6s-34,34.7-45.2,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,69s.9,2.1,4,5c2.6,2.5,5.7,5.3,5.7,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.3,94.2s-8.1-2.6-16.3-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.8,101.6s-1-1-3.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.3,65.9c-9.3-3.7-15.3-5.5-17.7-5.6-5.6-.2-11.2,5.3-11.2,5.3,0,0,11.9,4.8,18.2,3.4,6.4-1.4,10.7-3.1,10.7-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.8,83.1c-1-2.6,4.1-6.1,1.1-12-1.3-2.7-5.5-4.4-5.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.7,66.4s4.7-.5,4.4-3.1c-.3-2.9-4.4-2.4-4.6-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.7,85.6c1.6,4.8-7.7,10.2-11-.4-2.4-7.4,8.5-8.8-3.9-15.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.6,47.3c-12.1,0-16-4.8-16-4.8,0,0-3.5.7-9.4,3.3-2.7,1.2-5.6,4.1-8.3,6.6-10.8,9.8-15.2,15.3-15.2,15.3.8,1.2,1.9,3.2,1.8,5.8,0,1.8-9.2,9.9,1.6,26.6,10.7,16.7,34,34.7,45.2,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,69s-.9,2.1-4,5c-2.6,2.5-5.7,5.3-5.7,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.3,94.2s8.1-2.6,16.3-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.9,101.6s1-1,3.4-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M126.4,65.9c9.3-3.7,15.3-5.5,17.7-5.6,5.6-.2,11.2,5.3,11.2,5.3,0,0-11.9,4.8-18.2,3.4-6.4-1.4-10.7-3.1-10.7-3.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.9,83.1c1-2.6-4.1-6.1-1.2-12,1.3-2.7,5.5-4.4,5.5-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127,66.4s-4.7-.5-4.4-3.1c.3-2.9,4.4-2.4,4.6-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120,85.6c-1.6,4.8,7.7,10.2,11-.4,2.4-7.4-8.5-8.8,3.9-15.8"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175.9,252.7c-.8-4.5-6.7-9.8-6.7-9.8,0-.7,1.5-1.1,1.5-1.8,1-4,2.3-6.1,3.9-8.6,3.8-2.8,4.7-4.1,4.7-4.1,0,0-1.6-3.7-4.4-5.8,0,0-1.6,2.8-4.5,3.6h-4.1c0,.1-4.1,0-4.1,0-2.9-.8-4.5-3.6-4.5-3.6-2.8,2.1-4.4,5.8-4.4,5.8,0,0,.9,1.3,4.7,4.1,1.6,2.5,2.9,4.6,3.9,8.6,0,.6,1.6,1.1,1.5,1.8,0,0-5.9,5.3-6.7,9.8-.8,4.5-4.1,23.2-4.1,23.2l13.7,33.6,13.7-33.6s-3.3-18.7-4.1-23.2h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.1,210.5s-5.6-1.1-8.2-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,28.7c10,0,48.9,36.3,55.7,47.1,1.7,2.7,20.6,38.2,25.6,58.4,1.5,6.1-.2,25.7-2.9,27.8s-54.1,89.4-57.8,99.1-20.6,58.1-20.6,58.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,1.6c11.5,0,17.9-.7,21.4,1.6,3.5,2.3,39.4,20.9,43.7,25.6,4.3,4.7,14.3,22.2,16.7,31.3s8.7,71.2,16,95.5c7.2,24.3,15.4,41.3,12,49.5s-43.6,36.7-61.2,58.7c-17.6,22-48.6,57.4-48.6,57.4v31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.6,223.3s6.1,2.4,12.9,6.4c19.8,11.7,52.2,98,60.6,108.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.3,217.8s14.6,0,25.2-20.8c0,0,13.2,8.6,14.5,9.5,0,0-8.6,31.7-15.6,37.1,0,0-14.5-25.6-24.1-25.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.5,210.5s5.6-1.1,8.2-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M166.3,245.9s-3,6.1-2.2,7.4,2.2,1.8,2.2,1.8c0,0,1.5-.5,2.2-1.8s-2.2-7.4-2.2-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,28.7c-10,0-48.9,36.3-55.7,47.1-1.7,2.7-20.6,38.2-25.6,58.4-1.5,6.1.2,25.7,2.9,27.8s54.1,89.4,57.8,99.1,20.6,58.1,20.6,58.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,1.6c-11.5,0-17.9-.7-21.4,1.6-3.5,2.3-39.4,20.9-43.7,25.6-4.3,4.7-14.3,22.2-16.7,31.3-2.4,9.1-8.7,71.2-16,95.5-7.2,24.3-15.4,41.3-12,49.5s43.6,36.7,61.2,58.7c17.6,22,48.6,57.4,48.6,57.4v31.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75,223.3s-6.1,2.4-12.9,6.4c-19.8,11.7-52.2,98-60.6,108.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.3,217.8s-14.6,0-25.2-20.8c0,0-13.2,8.6-14.5,9.5,0,0,8.7,31.7,15.6,37.1,0,0,14.5-25.6,24.1-25.8h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.7,244s5.1-1.9,8.6-1.9,8.8,1.9,8.8,1.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.3,190.2c58-1.6,68-66.3,70.1-79.3-11,19.7-44.7,32.3-70.1,32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M166.3,168.6s10.8-10.2,19.2-11.4,30.5,6,30.5,6c0,0-12.1,16.4-24.3,20.4s-25.4,5.1-25.4,5.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.3,190.2c-58-1.6-68-66.3-70.1-79.3,11,19.7,44.7,32.3,70.1,32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M166.3,168.6s-10.8-10.2-19.2-11.4-30.5,6-30.5,6c0,0,12.1,16.4,24.3,20.4s25.4,5.1,25.4,5.1"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M100,124.9s12.6,6.5,12.2,9,15.9,9.5,20.1,9.4,13.4.4,17.4,1.6,10.6,2.7,13.3,2.6,9.2-3.1,13.4-2.6,15.5,1.3,17.8,1.1,16.1-6.6,18.1-7.7,21.6-10.4,21.6-13.4v-9.5s-13.8,15.4-26,19.5c-11.5,3.9-26.8,14-56,8.3-11.3-2.2-40.6-13.9-46.3-19.9s-8.1-6.1-8.1-6.1l2.6,7.7s0,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.8,122.9c1.2-.4,5,3.4,5,3.4,0,0,1.2,7.6.8,8.5s-6.2-3.9-6.2-3.9c0,0,.4-8,.4-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.1,131.6s-3.4,2.8-3.5,7.2l5.7,2.1s.7-4.8,1.4-7.5l-3.6-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.4,134.8c0-.6,4.9,0,4.9,0,0,0,4,9.3,4,10.2s-7-.8-7-.8l-1.9-9.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.9,149.1s.4-6.8,1.1-7.2,3-.5,3-.5c0,0,4.2-.1,4.2,1.5s-1.9,8.8-2.9,8.8-5.4-2.7-5.4-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.4,145.3c1.1-1.3,5.7.8,5.7.8,0,0,.9,7.6.4,9.2s-6.1,0-6.6-.2-1.6-7.4.4-9.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.3,146.2c.9-1.4,6.5-.9,7.1,1.2s2.3,8.8.4,10.3-5.1,2-5.9-.9-1.6-10.7-1.6-10.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.5,145.4c-1.1-1.4,7-2.8,7.8-1.8s.8,8.4-2.3,9.2-5.9-1.1-5.9-1.8,2.3-3.2.4-5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.8,148.1c-.8-1.1,2.5-8.6,5.4-9.2s5.1.2,5.1,1.3-1.8,7.4-4,7.9-5.4,1.6-6.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.7,136.6c0-1.4,6.4-6.4,8-6.2s3.4,6.7,2.7,8.7-4.2,4.1-6,2.7-4.8-5.1-4.8-5.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.7,128.5c.3-2.6,6-5.1,6.1-2.6.1,2.5-.5,10.9-2.5,12.2s-4.5-1.4-3.5-9.6h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.1,160s-5.4-9.4-4.5-9.8,8.3,1.1,8.3,2.8,2.6,8.4,1.2,8.4-5-1.4-5-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.8,164.4c-.3-1.1,2.2-8.8,3.2-8.7s5.2,1.3,5.2,2.8-1.6,8.6-3.4,8.6-5.1-2.8-5.1-2.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.8,175.8c-1.2-1.1,0-14.2.6-14.3s6.9.9,6.6,1.6,1,11.8-.5,12.7-6.7,0-6.7,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.6,181.5c-.6-2.3,1.1-10.3,3-11s5.6,1.1,5.7,2.6-.8,11.1-2.2,11.1-6.5-2.7-6.5-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169,172.5c0,.4,1.7,13,.7,14.1s-6.3,3.4-9.6-1.7c0,0,2.4-11,2.1-13.2h0s6.8.4,6.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.4,186.5c0-1.6,3.1-3.3,3.1-12.2,0,0,4.5-.3,4.6,1.7s.4,8.2-1.5,9.9-6.2.6-6.2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.5,182.7c-1.1-2.6-2.7-13.6-3.3-14.7s5.2-2.8,5.8-1.1,3,12.5,3,12.8-5.4,3-5.4,3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.8,176.8c-.4.3,7.1-.4,7.9-1.5s-.4-8.5-1.3-8.5-4.2-.5-4.7.5-.4,8.2-1.9,9.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.7,167.7c-2.5-.6-1.1-8.9,0-9.2s4.9-1.2,6-.9,1.7,2,1.1,3.8-5,6.7-7.1,6.3h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownlaugh);
export default __webpack_public_path__ + "static/media/unknown laugh.6af27dfb69d8c9ce16eab6c5051e7e92.svg";
export { ForwardRef as ReactComponent };